import { render, staticRenderFns } from "./approvalTree.vue?vue&type=template&id=3193a8e8"
import script from "./approvalTree.vue?vue&type=script&lang=js"
export * from "./approvalTree.vue?vue&type=script&lang=js"
import style0 from "./approvalTree.vue?vue&type=style&index=0&id=3193a8e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports